import { Box, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { observer, useLocalStore } from 'mobx-react-lite'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import StoreAchievement from '../Achievements/StoreAchievement'
import { autorun, reaction, when } from 'mobx'
import { useEffect, useMemo } from 'react'
import { ReactComponent as CheckedIcon } from './assets/CheckedIcon.svg'
import { ReactComponent as ChevronUp } from './assets/ChevronUp.svg'
import { get } from 'lodash'

const CenturionTable = observer(() => {
    const translate = useTranslate()

    const localObserver = useLocalStore(() => ({
        customers: [],
        sortOrder: 'desc' // 'asc' or 'desc'
    }))

    const sortedCustomers = useMemo(() => {
        const sorted = [...localObserver.customers].sort((a, b) => {
            const valueA = a.customer.centurionCount?.value || 0
            const valueB = b.customer.centurionCount?.value || 0
            return localObserver.sortOrder === 'desc' ? valueB - valueA : valueA - valueB
        })
        return sorted
    }, [localObserver.customers, localObserver.sortOrder])

    const toggleSort = () => {
        localObserver.sortOrder = localObserver.sortOrder === 'desc' ? 'asc' : 'desc'
    }

    useEffect(() => {
        const disposer = autorun(() => {
            if (StoreAchievement.getCenturions(StoreAchievement.getPeriodWithMonthDigit())[0]) {
                const items = StoreAchievement.getCenturions(StoreAchievement.getPeriodWithMonthDigit())?.[0]
              
                if (items) {
                    localObserver.customers = []
                    items.metricsDetails.count.customers.forEach(item => {
                        if (get(item.customer, 'centurionCount.value', 0) === 0) return null
                        localObserver.customers.push(item)
                    })
                }
            }
            
        })

        return () => {
            disposer()
        }
        
    }, [])

    return (
        <TableContainer component={Paper} elevation={0}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                borderBottom: 'none',
                                backgroundColor: 'rgba(227, 232, 237, 1)',
                                borderTopLeftRadius: '6px',
                                borderBottomLeftRadius: '6px',
                                padding: '16px 8px'
                            }}>
                            <Typography variant="body1" color="rgba(0, 55, 100, 1)" fontSize={'12px'} fontWeight={400} textAlign={'center'} lineHeight={'1'}>
                                {translate('member')}
                            </Typography>
                        </TableCell>
                        <TableCell
                            sx={{ borderBottom: 'none', backgroundColor: 'rgba(227, 232, 237, 1)', padding: '8px', cursor: 'pointer' }}
                            onClick={toggleSort}>
                            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} gap="4px">
                                <Typography
                                    variant="body1"
                                    color="rgba(0, 55, 100, 1)"
                                    fontSize={'12px'}
                                    fontWeight={400}
                                    textAlign={'center'}
                                    lineHeight={'1'}>
                                    {translate('count')}
                                </Typography>
                                <Box
                                    sx={{
                                        width: '16px',
                                        height: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        svg: {
                                            transform: localObserver.sortOrder === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.2s ease'
                                        }
                                    }}>
                                    <ChevronUp />
                                </Box>
                            </Stack>
                        </TableCell>
                        <TableCell
                            sx={{
                                borderBottom: 'none',
                                backgroundColor: 'rgba(227, 232, 237, 1)',
                                borderTopRightRadius: '6px',
                                borderBottomRightRadius: '6px',
                                padding: '8px'
                            }}>
                            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} gap="4px">
                                <Typography
                                    variant="body1"
                                    color="rgba(0, 55, 100, 1)"
                                    fontSize={'12px'}
                                    fontWeight={400}
                                    textAlign={'center'}
                                    lineHeight={'1'}>
                                    {translate('subscribe')}
                                </Typography>
                            </Stack>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedCustomers.map((centurion, index) => {
                        const bgcolor = index % 2 === 0 ? 'rgba(255, 255, 255, 1)' : 'rgba(245, 245, 245, 1)'
                        const rowKey = btoa(centurion.customer.id?.unicity + index + new Date().getTime())
                        if (centurion.customer.centurionCount.value === 0) return null
                        return (
                            <TableRow key={rowKey}>
                                <TableCell
                                    sx={{
                                        borderBottom: 'none',
                                        backgroundColor: bgcolor,
                                        borderTopLeftRadius: '6px',
                                        borderBottomLeftRadius: '6px',
                                        padding: '8px 12px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        maxWidth: '150px'
                                    }}>
                                    <Typography
                                        variant="body1"
                                        color="rgba(0, 55, 100, 1)"
                                        fontSize={'12px'}
                                        fontWeight={400}
                                        textAlign={'left'}
                                        lineHeight={'1.4'}>
                                        {centurion.customer.humanName.fullName}
                                    </Typography>
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none', backgroundColor: bgcolor, padding: '8px 12px' }}>
                                    <Typography
                                        variant="body1"
                                        color="rgba(0, 55, 100, 1)"
                                        fontSize={'12px'}
                                        fontWeight={400}
                                        textAlign={'center'}
                                        lineHeight={'1'}>
                                        {centurion.customer.centurionCount.value}
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    sx={{
                                        borderBottom: 'none',
                                        backgroundColor: bgcolor,
                                        borderTopRightRadius: '6px',
                                        borderBottomRightRadius: '6px',
                                        padding: '8px 12px'
                                    }}>
                                    <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                                        {centurion.customer.hasFeelGreatAutoOrder ? <CheckedIcon /> : ''}
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
})

export default CenturionTable
